import { useDataModel } from '@thd-nucleus/data-sources';

export const useUdsCallResponse = (customerId) => {
  const udsQueryOptions = {
    variables: {
      apiName: 'bogo',
      // This api key is temporary api key taken from sample in the UDS contract
      key: '2zSR74pj5Rq6zDtHENHkAScT4RWsl0pg',
      userId: customerId || '',
    },
    ssr: false,
    skip: !customerId
  };
  const { data, error, loading } = useDataModel('uds', udsQueryOptions);
  return {
    data,
    loading,
    error,
  };
};